import { Base64Document } from 'profile-api';

export function GetAnnouncementStatusDescription(announcementStatusCode: string) {
    let announcementStatuses = new Map();
    announcementStatuses.set('DRAFT','Bozza');
    announcementStatuses.set('APPROVAL','Inviato');
    announcementStatuses.set('PUBLISHED','Pubblicato');
    announcementStatuses.set('REFUSED','Rifiutato');
    announcementStatuses.set('OFFER_REFUSED','Offerte rifiutate');
    announcementStatuses.set('OFFER_ACCEPTED', 'Offerta accettata');

    let stat = announcementStatuses.get(announcementStatusCode);

    return (stat === undefined || stat === null) ? announcementStatusCode : stat;
}

export function GetAnnouncementTypeDescription(announcementTypeCode: string) {
  let announcementTypes = new Map();
  announcementTypes.set('SALE','Vendita');
  announcementTypes.set('RENTAL','Noleggio');
  
  let stat = announcementTypes.get(announcementTypeCode);

  return (stat === undefined || stat === null) ? announcementTypeCode : stat;
}

